import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Checklist } from './components/Checklist';
import { HistoriasPunoYLetra } from './components/HistoriasPunoYLetra';
import { Testimonials } from './components/Testimonials';
import { Checkout } from './components/Checkout';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Disable browser scroll restoration and force the page to start at the top
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#EFE4CC] text-slate-800 font-sans selection:bg-teal-200" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <Solution data-id="element-5" />
        <Tomos data-id="element-6" />
        <Bonos data-id="element-7" />
        <Checklist data-id="element-8" />
        <HistoriasPunoYLetra data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Checkout data-id="element-11" />
        <FAQ data-id="element-12" />
        <Guarantee data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}